import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../utils/axiosInstance';

export const userEditData = createAsyncThunk(
  'user/userEditData',
  async (formData: FormData, thunkAPI) => {
    try {
      const token = localStorage.getItem('viart_token');

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/user/edit`,
        formData,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (err: any) {
      return thunkAPI.rejectWithValue(
        err.response?.data?.message || 'Failed to update user'
      );
    }
  }
);


// Define the shape of user state
interface UserState {
  user: any | null;
  userData: any | null;
  loading: boolean;
  message: string;
  success: boolean;
  error: any | null;
}

const initialState: UserState = {
  user: null,
  userData: null,
  message: '',
  loading: false,
  success: false,
  error: null
};

const userEditSlice = createSlice({
  name: 'userEdit',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(userEditData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(userEditData.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;

        // Optional: update stored user if needed
        state.user = {
          ...state.user,
          ...action.payload.userData,
        };

        localStorage.setItem('viart_user', JSON.stringify(state.user));
      })
      .addCase(userEditData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
        state.success = false;
      });
  }
});

export default userEditSlice.reducer;
